import Colours from '../../../../../Theme/Colours';
import { Theme, ButtonWidth } from '../Buttons.types';

export const Styles = {
  common: {
    fontSize: 16,
    fontWeight: 600,
    lineHeight: '24px',
    height: '68px',
    minHeight: '68px',
    borderRadius: '0px 0px 0px 0px !important',
    '&:disabled': {
      color: Colours.Typography.light,
      boxShadow: '0px 2px 6px 1px rgba(0, 22, 99, 0.12)',
      opacity: '0.6'
    },
  },
  [Theme.primary]: {
    backgroundColor: Colours.PrimaryA.normal,
    color: Colours.Typography.light,
    '&:hover': {
      color: Colours.Typography.light,
      backgroundColor: Colours.PrimaryA.hovered,
    },
    '&:active': {
      color: Colours.Typography.light,
      backgroundColor: Colours.PrimaryA.pressed,
    },
    '&:focus': {
      color: Colours.Typography.light,
      backgroundColor: Colours.PrimaryA.pressed,
    },
  },
  [Theme.secondary]: {
    backgroundColor: Colours.Secondary.Green.normal,
    color: Colours.Typography.light,
    '&:hover': {
      color: Colours.Typography.light,
      backgroundColor: '#25A474',
    },
    '&:active': {
      color: Colours.Typography.light,
      backgroundColor: '#25A474',
    },
    '&:focus': {
      color: Colours.Typography.light,
      backgroundColor: '#25A474',
    },
    '&:disabled': {
      color: Colours.Typography.disabled,
      backgroundColor: Colours.Backgrounds.button,
    },
  },
  [Theme.secondaryAlternative]: {
    backgroundColor: '#50CF97',
    color: Colours.Typography.light,
    '&:hover': {
      color: Colours.Typography.light,
      backgroundColor: '#50B588',
    },
    '&:active': {
      color: Colours.Typography.light,
      backgroundColor: '#50B588',
    },
    '&:focus': {
      color: Colours.Typography.light,
      backgroundColor: '#50B588',
    },
    '&:disabled': {
      color: Colours.Typography.disabled,
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
    },
  },
  [Theme.danger]: {
    backgroundColor: Colours.Secondary.Red.normal,
    color: Colours.Typography.light,
    '&:hover': {
      color: Colours.Typography.light,
      backgroundColor: '#EA3E3F',
    },
    '&:active': {
      color: Colours.Typography.light,
      backgroundColor: '#EA3E3F',
    },
    '&:focus': {
      color: Colours.Typography.light,
      backgroundColor: '#EA3E3F',
    },
  },
  [Theme.defaultAlternative]: {
    color: Colours.Typography.light,
    backgroundColor: Colours.Typography.active,
    '&:hover': {
      color: Colours.Typography.light,
      backgroundColor: Colours.Typography.active,
    },
    '&:active': {
      color: Colours.Typography.light,
      backgroundColor: Colours.Typography.active,
    },
    '&:focus': {
      color: Colours.Typography.light,
      backgroundColor: Colours.Typography.active,
    },
  },
  [Theme.default]: {
    color: Colours.Typography.label,
    backgroundColor: 'unset',
    '&:hover': {
      color: Colours.Typography.label,
      backgroundColor: Colours.Backgrounds.button,
      borderColor: Colours.Borders.dark,
    },
    '&:active': {
      color: Colours.Typography.label,
      backgroundColor: Colours.Backgrounds.button,
      borderColor: Colours.Borders.dark,
    },
    '&:focus': {
      color: Colours.Typography.label,
      backgroundColor: Colours.Backgrounds.button,
      borderColor: Colours.Borders.dark,
    },
  },
  [Theme.dark]: {
    color: Colours.Typography.light,
    backgroundColor: Colours.Auxiliary.navigation,
    '&:hover': {
      color: Colours.Typography.light,
      backgroundColor: 'rgba(0, 25, 50, 0.85)',
    },
    '&:active': {
      color: Colours.Typography.light,
      backgroundColor: 'rgba(0, 25, 50, 0.85)',
    },
    '&:focus': {
      color: Colours.Typography.light,
      backgroundColor: 'rgba(0, 25, 50, 0.85)',
    },
  },

  [ButtonWidth.full]: {
    borderRadius: '0px 0px 24px 24px',
    boxShadow: '0px 2px 6px 1px rgba(0, 22, 99, 0.12)',
  },
  [ButtonWidth.halfLeft]: {
    borderRadius: '0px 0px 0px 24px',
  },
  [ButtonWidth.halfRight]: {
    borderRadius: '0px 0px 24px 0px',
  },
  [ButtonWidth.middle]: {
    borderRadius: '0px',
  },
};
